import { render, staticRenderFns } from "./QuizMusicToggle.vue?vue&type=template&id=76c07ecf&scoped=true&"
import script from "./QuizMusicToggle.vue?vue&type=script&lang=js&"
export * from "./QuizMusicToggle.vue?vue&type=script&lang=js&"
import style0 from "./QuizMusicToggle.vue?vue&type=style&index=0&id=76c07ecf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c07ecf",
  null
  
)

export default component.exports